<section class="row makePaymentView" id="productList-area vaxelis_restriction"
  style="padding: 100px;text-align: center;font-size: 25px;display: block;" *ngIf="asmStringCheck()">
  You are not eligible to view notifications
</section>
<section class="row makePaymentView" id="productList-area" *ngIf="!asmStringCheck()">
  <aside class="col-md-3 col-sm-3 col-lg-2 col-xs-12 applied-filter pr-0">
    <fieldset class="orderstatus-style">
      <div class="filterByGroup">
        <div class="filterByTitle">
          <label for="invoice">Categories</label>
          <div>
            <ng-select name="orderstatus" [items]="orderStatusList" [searchable]="false" [clearable]="false"
              bindLabel="name" bindValue="code" class="dropdown-credit" (change)="onKeyPress($event)"
              [(ngModel)]="orderStatus"></ng-select>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset id="filter-by">
      <legend class="filterByTitle-main order-history-search">
        {{ "ordersList.searchBy" | cxTranslate }}
      </legend>
      <div class="grey-line"></div>
      <div class="filterByGroup mb-3">
        <div class="filterByTitle">
          <label for="invoice">{{
            "ordersList.timeFrame" | cxTranslate
            }}</label>
        </div>
        <ng-select name="timeFrame" [items]="timeFrameList" [searchable]="false" [clearable]="false" bindLabel="name"
          bindValue="code" class="dropdown-credit" (ngModelChange)="clearDateRange()" [(ngModel)]="timeFrame">
        </ng-select>
      </div>

      <!--Date Range-->
      <div class="filterByGroup">
        <div class="filterByTitle mb-2">
          {{ "ordersList.dateRange" | cxTranslate }}
        </div>
        <div class="delivary-details">
          <div>
            <fieldset class="form-horizontal mb0">
              <legend class="control-group mb-2">
                <label for="fromDate" aria-labelledby="dataRange fromDate">{{
                  "ordersList.from" | cxTranslate
                  }}</label>
              </legend>
              <div class="headSearch-holder">
                <label class="searchbox orders-filter time-frame">
                  <!-- <div class="date-picker"> - With this date picker not opening on clicking icon-->
                  <img src="../../../assets/icons/{{baseSiteId}}/calendar.svg" alt="" />
                  <input type="text" placeholder="{{ 'ordersList.dateFormat' | cxTranslate }}" class="input-filter"
                    [(ngModel)]="fromDate" (ngModelChange)="validateDate()" bsDatepicker [maxDate]="maxSelectionDate"
                    [bsConfig]="{ containerClass: 'order-list-date',dateInputFormat: 'MM/DD/YYYY' }" />
                  <!--</div> -->
                </label>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="delivary-details">
          <div>
            <fieldset class="form-horizontal mb0">
              <legend class="control-group mb-2">
                <label for="toDate" aria-labelledby="dataRange toDate">{{
                  "ordersList.to" | cxTranslate
                  }}</label>
              </legend>
              <div class="headSearch-holder">
                <label class="searchbox orders-filter time-frame">
                  <!-- <div class="date-picker"> -->
                  <img src="../../../assets/icons/{{baseSiteId}}/calendar.svg" alt="" />
                  <input type="text" placeholder="{{ 'ordersList.dateFormat' | cxTranslate }}" class="input-filter"
                    [(ngModel)]="toDate" (ngModelChange)="validateDate()" bsDatepicker [maxDate]="maxSelectionDate"
                    [bsConfig]="{ containerClass: 'order-list-date',dateInputFormat: 'MM/DD/YYYY' }" />
                  <!--</div> -->
                </label>
              </div>
            </fieldset>
          </div>
        </div>
        <span class="dateError" *ngIf="dateError">{{
          "ordersList.invalidDateErrMsg" | cxTranslate
          }}</span>
        <span class="dateError" *ngIf="singleDateError">{{
          "ordersList.selectBothDate" | cxTranslate
          }}</span>
      </div>
      <!--End-->

      <div class="filterByGroup">
        <div class="filterByTitle mb-2">
          <label for="orderNumber">
            Customer, order or PO #
          </label>
        </div>

        <!-- <div class="headSearch-holder"> -->
        <!-- <app-product-search (selectedProductEvent)="getSelectedProduct($event)">
          </app-product-search> -->
        <!-- <div class="searchbox orders-filter time-frame"> -->
        <div class="search-input">
          <input placeholder="Search" type="text" autocomplete="off" aria-describedby="initialDescription"
            aria-controls="results" aria-autocomplete="both" class="input-filter" [(ngModel)]="searchNumber"
            (keyup)="onKeyPress($event.target.value)" (paste)="onKeyPress($event.target.value)" />
          <button role="presentation" class="search-icon">
            <!-- <cx-icon [type]="iconTypes.SEARCH"></cx-icon> -->
            <!-- <span class="searchicon"></span>
             -->
            <span class="searchicon" (click)="customOrderPoSearch()">
              <img src="../../../assets/icons/{{baseSiteId}}/search_new.svg">
            </span>
          </button>
        </div>
        <!-- </div>
        </div> -->
      </div>
      <div class="account-order-filter-btn">
        <button type="submit" class="btn-primary" data-di-id="di-id-362f2c77-5f23e741"
          [ngClass]="!isFilterSelected?'disable-btn':'enable-btn'" (click)="applyFilter()">
          {{ "ordersList.applyFilters" | cxTranslate }}
        </button>
        <button type="button" id="clearOrderFiltersBtn" class="btn-secondary" data-di-id="#clearOrderFiltersBtn"
          (click)="clearFilters()">
          {{ "ordersList.clearFilters" | cxTranslate }}
        </button>
      </div>
    </fieldset>
    <div class="line-intersection"></div>
    <section>
      <div>
        <!-- <app-need-assistance></app-need-assistance> -->
        <app-need-to-go-back></app-need-to-go-back>
      </div>
      <div class="line-intersection"></div>
    </section>
    <!-- <section>
      <div>
        <app-flu-dashboard-banner bannerComponent="OrderHistoryBannerComponent"></app-flu-dashboard-banner>
      </div>
    </section> -->
  </aside>
  <section class="col-md-9 col-sm-9 col-lg-10 table-s-section float-right">
    <section class="filter-section">
      <section class="row">
        <section class="col-sm-12 col-md-12 col-md-12 col-xs-12 op_ovice">
          <div id="filter-applied" class="applied-filter">
            <div class="row row-20 page-section">
              <div class="col-md-7 col-sm-6 hidden-xs filterApply-showing">
                <span>{{ "ordersList.showing" | cxTranslate }} {{ end }}
                  {{ "ordersList.of" | cxTranslate }}
                  {{ totalOrders }}
                  notifications</span>
              </div>
              <div class="col-md-5 col-sm-6 top-pagination left-pagination">
                <div class="time-frame">
                  <span class="top-page-id mr-2 pt-1" id="accPageInfo">{{ "ordersList.page" | cxTranslate }} {{ curPage
                    }}
                    {{ "ordersList.of" | cxTranslate }}
                    {{ numberOfPages() }}</span>
                  <div class="pagination">
                    <button [disabled]="curPage == 1" (click)="getCurrentPage('prev')" (click)="getNotificationList()"
                      class="pagination-btns mr-1">
                      <span class="chevronIconWhite prev"
                        style="background-image: url(/../../../assets/icons/{{baseSiteId}}/product-catalog-arrow.svg);"></span>
                    </button>

                    <button class="pagination-btns" [disabled]="
                      curPage >= totalOrders / pageSize ||
                      (totalOrders === 0 && pageSize === 0)
                    " (click)="getCurrentPage('next')" (click)="getNotificationList()">
                      <span class="chevronIconWhite next"
                        style="background-image: url(/../../../assets/icons/{{baseSiteId}}/product-catalog-arrow.svg);"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <hr class="hidden-xs" />
            <div class="row row-20" [ngClass]="
              facetsList?.length > 2 ? 'page-dropdown-ipad' : 'page-dropdown'
            ">
              <div class="col-md-8 col-sm-7 hidden-xs applied-filters">
                {{ "ordersList.filtersApplied" | cxTranslate }}
                <span *ngIf="!facetsList?.length">{{
                  "ordersList.none" | cxTranslate
                  }}</span>
                <span id="applied-filters" class="ml-2">
                  <span class="filterText focus mr-1 mb-2 filterTablet" tabindex="0" *ngFor="let filter of facetsList">
                    <div>
                      {{ filter.value
                      }}<img src="../../../assets/icons/{{baseSiteId}}/close_facet.png" alt="" class="remove-facet"
                        (click)="removeFacet(filter)" />
                      <span class="filterRemove"></span>
                    </div>
                  </span><a class="clear-filters ml-1" (click)="clearFilters()" *ngIf="facetsList?.length">{{
                    "ordersList.clearAllFilters" | cxTranslate }}</a>
                </span>
              </div>
              <div class="col-md-4 col-sm-5 col-xs-12 sortBy-select px-12">
                <ng-select name="pageSize" [items]="pageList" [searchable]="false" [clearable]="false" bindLabel="name"
                  bindValue="code" class="set-pagination" [(ngModel)]="pageSizeperPage" (change)="changePageSize()"
                  (change)="applyFilter()"></ng-select>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>

    <section class="payment-section filter-section">
      <section class="dispaly-refine">
        <ng-template #facetsRwd class="select-refine">
          <section class="modal-class">
            <section class="modal-heading">
              <h2>
                <span class="close-icon" aria-hidden="true" (click)="hide()">&times;</span>
              </h2>
              <h2 class="select-heading">
                {{ "plp.selectRefinement" | cxTranslate }}
              </h2>
            </section>
            <section>
              <fieldset class="orderstatus-style">
                <div class="filterByGroup">
                  <div class="filterByTitle">
                    <label for="invoice">Categories</label>
                    <div>
                      <ng-select name="orderstatus" [items]="orderStatusList" [searchable]="false" [clearable]="false"
                        bindLabel="name" bindValue="code" class="dropdown-credit" (change)="onKeyPress($event)"
                        [(ngModel)]="orderStatus"></ng-select>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset id="filter-by">
                <legend class="filterByTitle-main order-history-search">
                  Search by
                </legend>
                <div class="filterByGroup input-search">
                  <div class="filterByTitle">
                    <label for="invoice">{{
                      "ordersList.timeFrame" | cxTranslate
                      }}</label>
                  </div>
                  <ng-select name="timeFrame" [items]="timeFrameList" [searchable]="false" [clearable]="false"
                    bindLabel="name" bindValue="code" class="dropdown-credit" (ngModelChange)="clearDateRange()"
                    [(ngModel)]="timeFrame">
                  </ng-select>
                  <hr />
                </div>
                <div class="filterByGroup">
                  <div class="filterByTitle">
                    <label for="invoice">{{
                      "ordersList.dateRange" | cxTranslate
                      }}</label>
                  </div>
                  <div class="time-frame-mob">
                    <div class="pr-4 template-date">
                      <div class="control-group mb-2">
                        <label for="fromDate" aria-labelledby="dataRange fromDate">{{ "ordersList.from" | cxTranslate
                          }}</label>
                      </div>
                      <div class="headSearch-holder">
                        <label class="searchbox orders-filter time-frame">
                          <img src="../../../assets/icons/{{baseSiteId}}/calendar.svg" alt="" />
                          <input type="text" placeholder="{{
                            'ordersList.dateFormat' | cxTranslate
                          }}" class="input-filter delivery-pickup-calendar" [(ngModel)]="fromDate"
                            (ngModelChange)="validateDate()" bsDatepicker [maxDate]="maxSelectionDate"
                            [bsConfig]="{ containerClass: 'order-list-date',dateInputFormat: 'MM/DD/YYYY' }" />
                        </label>
                      </div>
                    </div>
                    <div class="template-to-date">
                      <div class="control-group mb-2">
                        <label for="toDate" aria-labelledby="dataRange toDate">{{ "ordersList.to" | cxTranslate
                          }}</label>
                      </div>
                      <div class="headSearch-holder">
                        <label class="searchbox orders-filter time-frame">
                          <img src="../../../assets/icons/{{baseSiteId}}/calendar.svg" alt="" />
                          <input type="text" placeholder="{{
                            'ordersList.dateFormat' | cxTranslate
                          }}" class="input-filter" [(ngModel)]="toDate" (ngModelChange)="validateDate()" bsDatepicker
                            [maxDate]="maxSelectionDate" [bsConfig]="{ containerClass: 'order-list-date',dateInputFormat: 'MM/DD/YYYY' }" />
                        </label>
                      </div>
                    </div>
                  </div>
                  <span class="dateError" *ngIf="dateError">{{
                    "ordersList.invalidDateErrMsg" | cxTranslate
                    }}</span>
                  <span class="dateError" *ngIf="singleDateError">{{
                    "ordersList.selectBothDate" | cxTranslate
                    }}</span>
                  <hr />
                </div>
                <div class="filterByGroup">
                  <div class="filterByTitle mb-2 mt-2">
                    <label for="invoice">Customer, order or PO #</label>
                  </div>
                  <div class="headSearch-holder input-search">
                    <label class="searchbox orders-filter time-frame">
                      <input placeholder="Search" type="text" autocomplete="off" aria-describedby="initialDescription"
                        aria-controls="results" aria-autocomplete="both" class="input-filter" [(ngModel)]="searchNumber"
                        (keyup)="onKeyPress($event.target.value)" 
                        (paste)="onKeyPress($event.target.value)"/>
                      <button role="presentation" class="search-icon" (click)="applyFilter('mobile')">
                        <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
                      </button>
                    </label>
                  </div>

                  <!--<div class="filterByTitle mb-2 mt-2">
                    <label for="poNumber">{{
                      "ordersList.po" | cxTranslate
                      }}</label>
                  </div>
                  <div class="headSearch-holder input-search">
                    <label class="searchbox orders-filter time-frame">
                      <input placeholder="Search" type="text" maxlength="35" autocomplete="off" aria-describedby="initialDescription"
                        aria-controls="results" aria-autocomplete="both" class="input-filter" [(ngModel)]="poNumber"
                        (keypress)="onKeyPress($event.target.value)" />
                      <button role="presentation" class="search-icon">
                        <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
                      </button>
                    </label>
                  </div>

                  <div class="filterByTitle mb-2 mt-2">
                    <label for="orderNumber">{{
                      "ordersList.order" | cxTranslate
                      }}</label>
                  </div>
                  <div class="headSearch-holder input-search">
                    <label class="searchbox orders-filter time-frame">
                      <input placeholder="Search" type="text" autocomplete="off" aria-describedby="initialDescription"
                        aria-controls="results" aria-autocomplete="both" class="input-filter" [(ngModel)]="order"
                        (keypress)="onKeyPress($event.target.value)" />
                      <button role="presentation" class="search-icon">
                        <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
                      </button>
                    </label>
                  </div>-->
                </div>
                <div class="account-order-filter-btn input-search">
                  <button type="button" class="btn btn-default btn-primary" (click)="applyFilter('mobile')" 
                  [ngClass]="!isFilterSelected? 'disable-btn' : 'enable-btn'">
                  <i class="fa fa-spinner fa-spin" *ngIf="applyFilterMobClicked"></i>
                    {{ "ordersList.applyFilters" | cxTranslate }}
                  </button>
                  <button type="button" id="clearOrderFiltersBtn" class="btn btn-secondary"
                    (click)="clearFilters()">
                    {{ "ordersList.clearFilters" | cxTranslate }}
                  </button>
                </div>
              </fieldset>
            </section>
            <!-- <footer class="p-2 input-search">
              <button class="btn btn-default blue-button" (click)="applyFilter('mobile')">
                {{ "ordersList.done" | cxTranslate }}
              </button>
            </footer> -->
          </section>
        </ng-template>
        <div class="account-order-filter-btn mb-1">
          <button class="btn btn-default white-button" data-di-id="#refineBtn" (click)="refine()">
            {{ "ordersList.refine" | cxTranslate }}
          </button>
        </div>
        <div class="sortBy-select pb-4 mobile-view-select">
          <ng-select name="pageSize" [items]="pageList" [searchable]="false" [clearable]="false" bindLabel="name"
            bindValue="code" class="dropdown-credit set-pagination" [(ngModel)]="pageSizeperPage"
            (change)="changePageSize()" (change)="applyFilter()"></ng-select>
        </div>
      </section>
      <section class="row">
        <div class="col-md-8 col-xs-6 mb-10">
          <span class="header-name">Notifications</span>
        </div>
      </section>
      <section>
        <p class="title_desc">
          Here's where you'll find a complete record of all your account activity, including orders and
          reservations,shipments, invoices and payments, account changes and more.</p>
      </section>
      <table aria-describedby="invoicesTable" id="ordersTable" class="order-list-table table table-striped">
        <thead>
          <tr>
            <th scope="col" class="date-title">

            </th>
            <th scope="col" class="type-title">
              PO# &nbsp;
            </th>
            <th scope="col" (click)="sortColumn($event, 'SENT_DT', notificationList, 'Date')" class="order-title">
              Date &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
          </tr>
        </thead>
        <tbody *ngIf="totalOrders">
          <tr *ngFor="
            let data of notificationList
            let i = index
          ">
            <td class="tab-col1">
              <span class="sub-order">
                <a (click)="onDetailsPage(data)"> {{ data.SUBJECT }}</a>
              </span>
              <span class="acc-no">
                Account {{ data.ACCOUNT_NUMBER }}
              </span>
              <span class="address">{{address}}</span>
            </td>
            <td>
              <span>{{ data.PO_NUMBER }}</span>
            </td>
            <td>
              <span>{{ data.SENT_DT }}</span>
            </td>
          </tr>
        </tbody>
      </table>

      <section class="orders-table-orders">
        <div class="row orders-row-table" *ngFor="let data of notificationList; let i = index">
          <ul>
            <li>
              <p>
                <b></b>
              </p>
              <p>
                <span class="sub-order">
                  <a (click)="onDetailsPage(data)"> {{ data.SUBJECT }}</a>
                </span>
                <span class="acc-no">
                  Account {{ data.ACCOUNT_NUMBER }}
                </span>
                <span class="address">{{address}}</span>
              </p>
            </li>
            <li>
              <p>
                <b>PO#</b>
              </p>
              <p>{{ data.PO_NUMBER }}</p>
            </li>
            <li>
              <p>
                <b>Account #</b>
              </p>
              <p>
                {{ data.SENT_DT }}
              </p>
            </li>
          </ul>
          <!-- <div class="column header-column orders-table-col">
            <section class="col-header-rwd">
              <p>
                <b></b>
              </p>
              <p>
                <b>
                  PO#
                </b>
              </p>
              <p>
                <b>
                  Date
                </b>
              </p>
            </section>
          </div>
          <div class="column desc-column">
            <section>
              <p>
                <span class="sub-order">
                  <a (click)="onDetailsPage(data)"> {{ data.SUBJECT }} | Order {{ data.ORDER_NUMBER }}</a>
                </span>
                <span class="acc-no">
                  Account {{ data.ACCOUNT_NUMBER }}
                </span>
                <span class="address">{{address}}</span>
              </p>
              <p>{{ data.PO_NUMBER }}</p>
              <p>
                {{ data.SENT_DT }}
              </p>
            </section>
          </div> -->
        </div>
      </section>

      <div *ngIf="notificationList?.length ==0 || notificationList === undefined" class="empty-list">
        No data available in table
      </div>
    </section>
    <section>
      <div id="prod-pagination">
        <p>
          {{ "ordersList.showing" | cxTranslate }} &nbsp;
          <span class="no_rec">{{ end }}</span>&nbsp; {{ "ordersList.of" | cxTranslate }} &nbsp;
          <span class="no_rec">{{ totalOrders }}</span>&nbsp; notifications
        </p>
        <p class="pagination align-btns">
          <button [disabled]="curPage == 1" (click)="getCurrentPage('prev')" (click)="getNotificationList()"
            class="pagination-btns mr-1">
            <span class="chevronIconWhite prev"
              style="background-image: url(/../../../assets/icons/{{baseSiteId}}/product-catalog-arrow.svg);"></span>
          </button>

          <button class="pagination-btns" [disabled]="
            curPage >= totalOrders / pageSize ||
            (totalOrders === 0 && pageSize === 0)
          " (click)="getCurrentPage('next')" (click)="getNotificationList()">
            <span class="chevronIconWhite next"
              style="background-image: url(/../../../assets/icons/{{baseSiteId}}/product-catalog-arrow.svg);"></span>
          </button>
        </p>
        <p>
          <span>{{ "ordersList.page" | cxTranslate }} {{ curPage }}
            {{ "ordersList.of" | cxTranslate }} {{ numberOfPages() }}</span>
        </p>
      </div>
    </section>

    <div class="line-intersection mobile-view"></div>
    <section class="mobile-view">
      <div>
        <!-- <app-need-assistance></app-need-assistance> -->
        <app-need-to-go-back></app-need-to-go-back>
      </div>
      <div class="line-intersection"></div>
    </section>
    <section class="mobile-view">
      <div class="banner-img">
        <app-flu-dashboard-banner bannerComponent="OrderHistoryBannerComponent"></app-flu-dashboard-banner>
      </div>
    </section>
  </section>
</section>